<template>
  <AtomHorizontalScroll>
    <div class="nav no-scrollbar">
      <NuxtLink v-for="item in items" :key="item.text" :to="{ name: item.name, params: { league: league.slug }, query: item.query }" :class="{ 'active': item.active }">
        {{ item.text }}
      </NuxtLink>
    </div>
  </AtomHorizontalScroll>
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
const league = useLeagueStore()

const items = computed(() => [
  {
    text: t('shared.nav.start'),
    name: 'leagues-league',
    active: route.name === 'leagues-league',
  },
  {
    text: t('shared.nav.teams'),
    name: 'leagues-league-teams',
    active: route.name === 'leagues-league-teams',
    query: {
      ...route.query
    }
  },
  {
    text: t('shared.nav.fixtures'),
    name: 'leagues-league-fixtures',
    active: route.name === 'leagues-league-fixtures',
    query: {
      ...route.query
    }
  },
  {
    text: t('shared.nav.results'),
    name: 'leagues-league-results',
    active: route.name === 'leagues-league-results',
    query: {
      ...route.query
    }
  },
  {
    text: t('shared.nav.table'),
    name: 'leagues-league-table',
    active: route.name === 'leagues-league-table',
    query: {
      ...route.query
    }
  },
  // {
  //   text: t('shared.nav.statistics'),
  //   name: 'leagues-league-statistics',
  //   active: route.name === 'leagues-league-statistics',
  // }
])
</script>